import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetNotificationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Notification/GetList?` + params, null);

export const SaveNotificationLog = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Notification/Save`, data);

export const GetUpcomingVaccinationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Notification/GetUpcomingVaccinationList?` + params, null);

export const GetUpcomingFollowUpList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/Notification/GetUpcomingFollowUpList?` + params, null);

export const SendEmailNotification = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Notification/SendEmailReminder`, data);

export const SendSmsNotification = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Notification/SendSmsReminder`, data);

export const UpdateNotificationLog = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Notification/UpdateNotification`, data);

export const GetFollowUpMessagePreview = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Notification/GetFollowUpMessagePreview?`, data);

export const GetVaccinationMessagePreview = (data: any) =>
    POST_ENC(`${BASE_URL}/api/Notification/GetVaccinationMessagePreview?`, data);